import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { spacing } from '../constants/spacing';
import { typography } from '../constants/typography';
import { useAppColors } from '../context/PreferencesContext';

type Props<T extends string> = {
  options: readonly T[];
  value: T;
  onChange: (value: T) => void;
};

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
}: Props<T>) {
  const palette = useAppColors();

  return (
    <View
      style={[
        styles.track,
        { backgroundColor: palette.surface, borderColor: palette.border },
      ]}
    >
      {options.map(option => {
        const selected = option === value;
        return (
          <Pressable
            key={option}
            accessibilityRole="button"
            accessibilityState={{ selected }}
            accessibilityLabel={option}
            onPress={() => onChange(option)}
            style={[
              styles.segment,
              selected && {
                backgroundColor: palette.primary,
              },
            ]}
          >
            <Text
              style={[
                styles.label,
                { color: selected ? palette.onPrimary : palette.textSecondary },
              ]}
            >
              {option}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  track: {
    flexDirection: 'row',
    borderWidth: 1,
    borderRadius: 12,
    padding: spacing.xs,
    gap: spacing.xs,
  },
  segment: {
    flex: 1,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
  },
  label: {
    ...typography.caption,
    fontWeight: '700',
  },
});
